import { ListTodo } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { linearWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  linearWeb,
  {
    LinearPage: () => import('./LinearPage'),
    LinearAssociationChip: () => import('./LinearAssociationChip'),
    LinearIssueContextProvider: () => import('./LinearIssueContextProvider'),
  },
  {
    icons: { ListTodo },
  },
);
